import React from "react";

import { IoExitOutline } from "react-icons/io5";
import companyLogo from "assets/company-logo.svg";
import PropTypes from "prop-types";

const AiRoomHeader = ({ setInterviewCompletionStatusHandler }) => {
  return (
    <div className="header">
      <img
        alt="logo"
        style={{ height: "25px" }}
        src={companyLogo}
        className="meeting-room-log"
      />
      <button
        onClick={() => {
          setInterviewCompletionStatusHandler();
        }}
        className="btn border-0  text-danger d-flex align-items-center gap-2"
      >
        Leave interview{" "}
        <IoExitOutline className="fw-bold" style={{ fontSize: "18px" }} />
      </button>
    </div>
  );
};

export default AiRoomHeader;

AiRoomHeader.propTypes = {
  setInterviewCompletionStatusHandler: PropTypes.any.isRequired,
};
